import { createContext } from 'react';
// The ! here tells typescript that this context will always have a value even
// though we can't default it here. It's set in our components and used nowhere
// else so we know this is true.
export const PropertyContext = /*#__PURE__*/createContext(undefined);